import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { formatUnderScoreLowerCase, getAmplitudeKeyValue } from '@utils/utils';

type ReasonData = {
  id: number;
  reason: string;
};

export function logWithdrawalRequest(
  amplitudeAccountName: string,
  withdrawalAmount: number,
  reasonData: ReasonData,
  validatedReferralCode: string,
  transaction_category_id: string,
  source: string,
  meAmplitudeContext: any,
): void {
  const e = AMPLITUDE_CONSTANTS.Withdrawal.applyForWithdrawal;
  const { name, attributes } = e;
  AmplitudeHelper.logEvent(name, {
    [attributes.transaction_category_id]: transaction_category_id,
    [attributes.dynamic_account_name]: amplitudeAccountName,
    [attributes.requested_amount]: Math.floor(withdrawalAmount),
    [attributes.reason_id]: reasonData?.id,
    [attributes.reason]: formatUnderScoreLowerCase(reasonData.reason),
    [attributes.source]: source,
    [attributes.referral_code]: validatedReferralCode,
    ...getAmplitudeKeyValue(e.name, meAmplitudeContext),
  });
}

export function logHideReasonsModal(source: string, amplitudeAccountName: string, validatedReferralCode: string): void {
  const e = AMPLITUDE_CONSTANTS.Withdrawal.reasonsModalClose;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
    [e.attributes.dynamic_account_name]: amplitudeAccountName,
    [e.attributes.referral_code]: validatedReferralCode,
  });
}

export function logShowReasonsModal(source: string, amplitudeAccountName: string, validatedReferralCode: string): void {
  const e = AMPLITUDE_CONSTANTS.Withdrawal.reasonsModal;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: source,
    [e.attributes.dynamic_account_name]: amplitudeAccountName,
    [e.attributes.referral_code]: validatedReferralCode,
  });
}
